import PropTypes from 'prop-types';
import {Translate, I18n} from 'react-redux-i18n';
import Modal from 'react-modal';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import {withRouter} from 'react-router-dom';

import {DocumentDossierChips, Icon, AbstractFormComponent} from 'front-onceforall-core';
import {requiredValidator} from 'front-onceforall-core/dist/utils/validators';

const MAX_LENGTH_ADDITIONAL_DESIGNATION = 100;

const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(255,255,255,0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 2
  },
  content: {
    backgroundColor: '#fff',
    borderRadius: 4,
    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 0px 32px 0px',
    minWidth: 450,
    outline: 0,
    padding: 20,
    position: 'relative'
  }
};

export class EditAdditionalDesignationModal extends AbstractFormComponent {
  getFormData() {
    return {
      additionalDesignation: this.props.document.additionalDesignation || ''
    };
  }

  getFormValidators() {
    return {
      additionalDesignation: this.props.isRequired ? requiredValidator : undefined
    };
  }

  handleSubmitCallback() {
    if (
      this.props.document.additionalDesignation !== this.state.formData.additionalDesignation
    ) {
      this.props.onSubmit(this.state.formData.additionalDesignation);
    } else {
      this.props.onClose();
    }
  }

  render() {
    const valueLength = this.state.formData.additionalDesignation.length;
    return (
      <Modal
        className="col-md-8 col-lg-6 col-xl-4"
        defaultStyles={modalStyles}
        isOpen
        onRequestClose={this.props.onClose}
        ariaHideApp={false}
        shouldCloseOnOverlayClick
      >
        <div
          style={{
            borderRadius: '4px',
            backgroundColor: '#fff',
            boxShadow: '0 16px 32px 0 rgba(0, 0, 0, 0.32)',
            overflow: 'hidden',
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center'
          }}
        >
          <div style={{padding: 20}}>
            <div className="flex-container column center">
              <h3>{this.props.document.type.name}</h3>
              <div className="my-3">
                <DocumentDossierChips
                  dossiers={this.props.document.dossiers}
                  handleClickProject={idProject => this.props.history.push(`/project/${idProject}`)}
                />
              </div>
            </div>
            <form onSubmit={this.handleSubmit}>
              <TextField
                autoFocus
                label={this.getFieldLabel('document.additionalDesignation', this.props.isRequired)}
                id="additionalDesignation"
                name="additionalDesignation"
                value={this.state.formData.additionalDesignation}
                onChange={this.handleChange('additionalDesignation')}
                error={this.isOnError('additionalDesignation')}
                helperText={this.helperText('additionalDesignation')}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <span
                        className="information"
                        tooltip={I18n.t('document.additionalDesignationNotice')}
                        flow="left"
                      >
                        <Icon
                          icon="info"
                          size={20}
                        />
                      </span>
                    </InputAdornment>
                  )
                }}
                inputProps={{
                  maxLength: MAX_LENGTH_ADDITIONAL_DESIGNATION
                }}
              />
              <Translate
                value="message.textCounter"
                counter={valueLength}
                maxLength={MAX_LENGTH_ADDITIONAL_DESIGNATION}
              />

              <div className="actions col-12 inline-container space-between">
                <button
                  type="button"
                  className="large secondary inline-container"
                  onClick={this.props.onClose}
                  data-id="cancel"
                >
                  <Icon icon="go-back"/>
                  <Translate value="action.cancel"/>
                </button>
                <button
                  className="large primary inline-container"
                  id="submit"
                  type="submit"
                  disabled={this.props.submitting}
                >
                  <Icon icon={this.props.submitting ? 'loader' : 'check'}/>
                  <Translate value="action.confirm"/>
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    );
  }
}

EditAdditionalDesignationModal.propTypes = {
  document: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  isRequired: PropTypes.bool.isRequired
};

export default withRouter(EditAdditionalDesignationModal);
